module.exports = __webpack_public_path__ + "static/bison-ddd1b4d555fb64186832dd5674718851.mp4";